// @ts-nocheck
import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects'
import { sanitizeTelephone } from '../../helpers'
import { appsUsernameSelected } from '../../helpers/app'
import { urls } from '../../routing'
import { AuthenticationService, LiteralsService } from '../../services'
import {
  checkSessionAction,
  confirmVerificationCodeFailedAction,
  confirmVerificationCodeSuccessfulAction,
  resendVerificationCodeFailedAction,
  resendVerificationCodeSuccessfulAction,
  setIsConfirmingVerificationCodeAction,
  setIsResendingVerificationCodeAction,
  setNotificationAction,
  setVerificationOriginAction
} from '../actions'
import { IStoreState } from '../states'
import { VerificationTypeKeys } from '../types'

// Worker Saga
function* fetchVerificationCodeAsync() : any {
  const routerHistory = yield getContext('routerHistory')

  try {
    yield put(setIsConfirmingVerificationCodeAction())
    const state = yield select((state: IStoreState) => state)
    const dni = appsUsernameSelected?.username === 'phone'
      ? sanitizeTelephone(
          (state.verification.phone || state.signUp.phone || '').trim(),
          state.verification.callingCode || state.signUp.callingCode
        )
      : state.verification.dni ? state.verification.dni : state.signUp.dni
    const code = yield select((state: IStoreState) => state.verification.code)
    const origin = yield select((state: IStoreState) => state.verification.origin)
    yield call(AuthenticationService.confirmSignUp, dni, code)
    yield put(setVerificationOriginAction(null))
    if (origin === 'recoverPassword') {
      const { email: recoverEmail } = yield select((state: IStoreState) => state.recoverPassword)
      yield call(AuthenticationService.requestRecoverPasswordCode, recoverEmail)
      yield put(confirmVerificationCodeSuccessfulAction())
      yield put(
        setNotificationAction({
          isError: false,
          label: LiteralsService.get('accountVerified', true),
        })
      )
      yield call(routerHistory.replace, urls.recoverPasswordRestoreStep)
      return
    }
    try {
      const { dni: signUpDni, password } = yield select(
        (state: IStoreState) => state.signUp
      )
      if (password === '') {
        yield put(confirmVerificationCodeSuccessfulAction())
        yield put(
          setNotificationAction({
            isError: false,
            label: LiteralsService.get('accountVerified', true),
          })
        )
        yield call(routerHistory.replace, urls.signIn)
        return
      }
      let username = signUpDni
      yield call(AuthenticationService.signIn, {
        username,
        password
      })
      yield put(checkSessionAction())
    } catch (error) {
      yield put(confirmVerificationCodeSuccessfulAction())
      yield call(routerHistory.replace, urls.signIn)
    }
  } catch (error: any) {
    const errorKey = error?.name || error?.code || error?.underlyingError?.name
    yield put(confirmVerificationCodeFailedAction())
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.getOrDefault(errorKey, 'serverError', true),
      })
    )
  }
}

function* resendVerificationCodeAsync() : any {
  const routerHistory = yield getContext('routerHistory')

  try {
    yield put(setIsResendingVerificationCodeAction())
    const state = yield select((state: IStoreState) => state)
    const dni = appsUsernameSelected?.username === 'phone'
      ? sanitizeTelephone(
          (state.verification.phone || state.signUp.phone || '').trim(),
          state.verification.callingCode || state.signUp.callingCode
        )
      : state.signUp.dni
    yield call(AuthenticationService.resendSignUpConfirmationCode, dni)
    yield put(resendVerificationCodeSuccessfulAction())
    yield put(
      setNotificationAction({
        isError: false,
        label: LiteralsService.get('verificationCodeSent', true)
      })
    )
    yield call(routerHistory.replace, urls.accountVerificationStep)
  } catch (error: any) {
    const errorKey = error?.name || error?.code || error?.underlyingError?.name
    yield put(resendVerificationCodeFailedAction())
    yield put(
      setNotificationAction({
        isError: true,
        label: LiteralsService.getOrDefault(errorKey, 'serverError', true),
      })
    )
  }
}

// Watcher Saga:
function* watchFetchVerificationAsync() {
  yield takeLatest(VerificationTypeKeys.CONFIRM_VERIFICATION_CODE, fetchVerificationCodeAsync)
}

function* watchResendVerificationAsync() {
  yield takeLatest(VerificationTypeKeys.RESEND_VERIFICATION_CODE, resendVerificationCodeAsync)
}

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([watchFetchVerificationAsync(), watchResendVerificationAsync()])
}
